'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InboxChatBubbleTooltip = function InboxChatBubbleTooltip(props) {
  return _react2.default.createElement(
    _UITooltip2.default,
    {
      innerClassName: 'inbox-chat-bubble',
      placement: props.placement,
      title: props.title,
      style: {
        maxWidth: '15.5rem'
      }
    },
    _react2.default.createElement(
      'span',
      { style: { maxWidth: '75%' } },
      props.children
    )
  );
};

InboxChatBubbleTooltip.propTypes = {
  children: _react.PropTypes.node.isRequired,
  placement: _react.PropTypes.string,
  title: _react.PropTypes.node.isRequired
};

exports.default = InboxChatBubbleTooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/InboxChatBubbleTooltip.js
// module id = 1117
// module chunks = 2 3